"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.rootRewardsState = exports.extractRewardState = exports.deleteRewardState = exports.editRewardState = exports.createRewardState = exports.rewardRedeemedUsersState = exports.rewardState = exports.rewardsState = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _redux = require("redux");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var rewardsState = {
  data: {
    hits: undefined,
    nbHits: undefined,
    nbPages: undefined,
    page: undefined
  },
  isLoading: false,
  error: null
};
exports.rewardsState = rewardsState;

var rewardsReducer = function rewardsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rewardsState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'LOAD_REWARDS':
      return _objectSpread({}, state, {
        isLoading: true,
        error: null
      });

    case 'LOAD_REWARDS_SUCCESS':
      {
        var hitsState = state.data.hits || [];
        var hitsNextState = action.payload.hits || [];
        var hits = [].concat((0, _toConsumableArray2["default"])(hitsState), (0, _toConsumableArray2["default"])(hitsNextState));
        return _objectSpread({}, state, {
          isLoading: false,
          data: {
            hits: hits,
            nbHits: action.payload.nbHits,
            nbPages: action.payload.nbPages,
            page: action.payload.page
          }
        });
      }

    case 'LOAD_REWARDS_ERROR':
      return _objectSpread({}, state, {
        isLoading: false,
        error: action.payload.error
      });

    case 'LOAD_REWARDS_RESET':
      return rewardsState;

    default:
      return state;
  }
};

var rewardState = {
  data: null,
  isLoading: false,
  error: null
};
exports.rewardState = rewardState;

var rewardReducer = function rewardReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rewardState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'LOAD_REWARD':
      return _objectSpread({}, state, {
        isLoading: true,
        error: null
      });

    case 'LOAD_REWARD_SUCCESS':
      return _objectSpread({}, state, {
        isLoading: false,
        data: action.payload
      });

    case 'LOAD_REWARD_ERROR':
      return _objectSpread({}, state, {
        isLoading: false,
        error: action.payload.error
      });

    case 'LOAD_REWARD_RESET':
      return rewardState;

    default:
      return state;
  }
};

var rewardRedeemedUsersState = {
  data: null,
  meta: null,
  isLoading: false,
  error: null
};
exports.rewardRedeemedUsersState = rewardRedeemedUsersState;

var rewardRedeemedUsersReducer = function rewardRedeemedUsersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rewardRedeemedUsersState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'LOAD_REWARD_REDEEMED_USERS':
      return _objectSpread({}, state, {
        isLoading: true,
        error: null
      });

    case 'LOAD_REWARD_REDEEMED_USERS_SUCCESS':
      {
        var _ref = action || {},
            _ref$payload = _ref.payload;

        _ref$payload = _ref$payload === void 0 ? {} : _ref$payload;
        var _ref$payload$meta = _ref$payload.meta,
            meta = _ref$payload$meta === void 0 ? null : _ref$payload$meta,
            _ref$payload$data = _ref$payload.data,
            data = _ref$payload$data === void 0 ? [] : _ref$payload$data;

        var _ref2 = meta || {},
            skip = _ref2.skip;

        return _objectSpread({}, state, {
          isLoading: false,
          data: meta && skip ? [].concat((0, _toConsumableArray2["default"])(state.data || []), (0, _toConsumableArray2["default"])(data || [])) : data,
          meta: action.payload.meta
        });
      }

    case 'LOAD_REWARD_REDEEMED_USERS_ERROR':
      return _objectSpread({}, state, {
        isLoading: false,
        error: action.payload.error
      });

    case 'LOAD_REWARD_REDEEMED_USERS_RESET':
      return rewardRedeemedUsersState;

    default:
      return state;
  }
};

var createRewardState = {
  createdRewardId: null,
  isLoading: false,
  error: null
};
exports.createRewardState = createRewardState;

var createRewardReducer = function createRewardReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : createRewardState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'CREATE_REWARD':
      return _objectSpread({}, state, {
        isLoading: true,
        error: null
      });

    case 'CREATE_REWARD_SUCCESS':
      return _objectSpread({}, state, {
        isLoading: false,
        error: null,
        createdRewardId: action.payload
      });

    case 'CREATE_REWARD_ERROR':
      return _objectSpread({}, state, {
        isLoading: false,
        error: action.payload.error
      });

    case 'CREATE_REWARD_RESET':
      return createRewardState;

    default:
      return state;
  }
};

var editRewardState = {
  editedRewardId: null,
  isLoading: false,
  error: null
};
exports.editRewardState = editRewardState;

var editRewardReducer = function editRewardReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : editRewardState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'EDIT_REWARD':
      return _objectSpread({}, state, {
        isLoading: true,
        error: null
      });

    case 'EDIT_REWARD_SUCCESS':
      return _objectSpread({}, state, {
        isLoading: false,
        error: null,
        editedRewardId: action.payload
      });

    case 'EDIT_REWARD_ERROR':
      return _objectSpread({}, state, {
        isLoading: false,
        error: action.payload.error
      });

    case 'EDIT_REWARD_RESET':
      return editRewardState;

    default:
      return state;
  }
};

var deleteRewardState = {
  hasBeenDeleted: null,
  isLoading: false,
  error: null
};
exports.deleteRewardState = deleteRewardState;

var deleteRewardReducer = function deleteRewardReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : deleteRewardState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'DELETE_REWARD':
      return _objectSpread({}, state, {
        isLoading: true,
        error: null
      });

    case 'DELETE_REWARD_SUCCESS':
      return _objectSpread({}, state, {
        isLoading: false,
        error: null,
        hasBeenDeleted: true
      });

    case 'DELETE_REWARD_ERROR':
      return _objectSpread({}, state, {
        isLoading: false,
        error: action.payload.error
      });

    case 'DELETE_REWARD_RESET':
      return deleteRewardState;

    default:
      return state;
  }
};

var extractRewardState = {
  data: null,
  isLoading: false,
  error: null
};
exports.extractRewardState = extractRewardState;

var extractRewardReducer = function extractRewardReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : extractRewardState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'EXTRACT_REWARD':
      return _objectSpread({}, state, {
        data: null,
        isLoading: true,
        error: null
      });

    case 'EXTRACT_REWARD_SUCCESS':
      return _objectSpread({}, state, {
        isLoading: false,
        error: null,
        data: action.payload.data
      });

    case 'EXTRACT_REWARD_ERROR':
      return _objectSpread({}, state, {
        isLoading: false,
        error: action.payload.error
      });

    case 'EXTRACT_REWARD_RESET':
      return extractRewardState;

    default:
      return state;
  }
};

var rootRewardsState = {
  loadRewards: rewardsState,
  loadReward: rewardState,
  loadRewardRedeemedUsers: rewardRedeemedUsersState,
  createReward: createRewardState,
  editReward: editRewardState,
  deleteReward: deleteRewardState,
  extractReward: extractRewardState
};
exports.rootRewardsState = rootRewardsState;

var _default = (0, _redux.combineReducers)({
  loadRewards: rewardsReducer,
  loadReward: rewardReducer,
  loadRewardRedeemedUsers: rewardRedeemedUsersReducer,
  createReward: createRewardReducer,
  editReward: editRewardReducer,
  deleteReward: deleteRewardReducer,
  extractReward: extractRewardReducer
});

exports["default"] = _default;
//# sourceMappingURL=reducers.js.map